<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/p27mPv/tc-custom/9781609259990.jpg?1737056567759" alt="This image is the cover for the book Living Long, Living Passionately"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Living Long, Living Passionately
      </h1>
      <p class="bookDescription body article font2">
        <b>“These inspirational lessons . . . not only invite reflection but encourage readers to improve their own and others’ lives.” —<i>Library Journal</i></b><br/><br/>The world doesn’t always slow down when we want it to. This twelve-step guided meditative handbook by bestselling author Karen Casey shows how to find calm amid the chaos using the power of daily contemplation, especially as we get older, gain wisdom, and move into a new stage of life.<br/><br/>Exploring such topics as fear and love, resistance and acceptance, willpower, and discernment—and with accompanying questions and prompts—each of the seventy-five essays in this book addresses an aspect of life that helps you move one step closer to happiness and peace. We don’t know what the future holds, but if we dwell on the future we miss our chance to appreciate the present and all the beauty it contains. Benefit from this inspirational guide that contains:Daily meditation and prayer practicesA Twelve-Step “Course in Miracles”Guidance on how to live the best life you can live and much more
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Karen Casey
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Conari Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a915c4e